import { render, staticRenderFns } from "./BaseTableG3.vue?vue&type=template&id=408eb833"
import script from "./BaseTableG3.vue?vue&type=script&lang=js"
export * from "./BaseTableG3.vue?vue&type=script&lang=js"
import style0 from "./BaseTableG3.vue?vue&type=style&index=0&id=408eb833&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports